import { useEffect } from "react";

export default function TermsOfService() {
  useEffect(() => {
    document.title = "Terms of Service · Ram Shack";
  }, []);

  return (
    <main
      data-testid="terms-of-service-page"
      className="min-h-screen px-6 md:px-12 lg:px-16 py-24 max-w-3xl mx-auto"
    >
      <div className="overline mb-4">Ram Shack</div>
      <h1 className="font-serif-display text-4xl sm:text-5xl text-bone mb-2">
        Terms of Service
      </h1>
      <div className="text-xs uppercase tracking-[0.24em] text-muted-bone mb-12">
        Last updated · February 2026
      </div>

      <div className="space-y-8 text-muted-bone text-[15px] leading-relaxed">
        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">1. Age & jurisdiction</h2>
          <p>
            By entering ramshack.toys you affirm that you are at least 18 years of age
            — or 21 where that is the applicable minimum legal age in your jurisdiction —
            and that adult material is legal where you reside. If either is untrue,
            you must leave immediately.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">2. Orders & pricing</h2>
          <p>
            All prices are shown in USD. Placing an order is an offer to purchase; it
            is not accepted until we send an order confirmation email. We reserve the
            right to refuse or cancel any order, refund the full amount, and remove
            products at any time without notice.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">3. Shipping</h2>
          <p>
            Physical goods ship discreetly via our contracted suppliers. Delivery
            timelines are estimates — carrier delays are outside our control.
            International customers are responsible for local duties and taxes.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">4. Returns</h2>
          <p>
            For hygiene reasons, intimate products (lingerie worn against skin,
            wellness liquids, toys with broken seals) cannot be returned once
            opened. Sealed, unused items may be returned within 14 days for
            store credit. Defective items are replaced free of charge — contact{" "}
            <a href="mailto:care@ramshack.toys" className="text-bone underline">care@ramshack.toys</a>.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">5. Acceptable use</h2>
          <p>
            You agree not to use Ram Shack to harass staff, submit fraudulent orders,
            reverse-engineer the site, scrape our catalog, or resell our products
            through unauthorized channels. Accounts violating these terms will be
            closed and any pending orders refunded.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">6. Content & IP</h2>
          <p>
            All copy, photography, custom illustration, ambient audio, and site code
            on ramshack.toys are the property of Ram Shack unless otherwise noted.
            Product photography for manufacturer catalog items remains the property
            of the respective brands. You may not reproduce or redistribute site
            content without written permission.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">7. Companions & AI-generated content</h2>
          <p>
            Companion characters and any AI-generated responses on Ram Shack are
            fictional. They do not represent real persons and are provided for
            entertainment only. Do not rely on Companion messages for medical,
            legal, or financial advice.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">8. Limitation of liability</h2>
          <p>
            To the fullest extent permitted by law, Ram Shack&apos;s aggregate liability
            for any claim arising from your use of the site is limited to the amount
            you paid us in the 90 days preceding the claim. We disclaim all implied
            warranties.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">9. Changes</h2>
          <p>
            We may update these terms. The &ldquo;Last updated&rdquo; date at the top
            of this page reflects the current version. Continued use of the site
            after changes constitutes acceptance.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-bone mb-3">10. Contact</h2>
          <p>
            Questions? Write to{" "}
            <a href="mailto:care@ramshack.toys" className="text-bone underline">care@ramshack.toys</a>.
          </p>
        </section>
      </div>
    </main>
  );
}
